var Country;
(function (Country) {
    Country["AU"] = "AU";
    Country["US"] = "US";
    Country["GB"] = "GB";
    Country["NZ"] = "NZ";
    Country["CA"] = "CA";
    Country["FR"] = "FR";
    Country["ES"] = "ES";
    Country["IT"] = "IT";
})(Country || (Country = {}));

export { Country };
